<template>
  <td
    @click="$emit('click')"
    @contextmenu="$emit('contextmenu', $event)"
    class="tube-container"
    :class="[{ selected: isSelected && tubeNumber}, {borders: !!getHeight()}]"
    :style="{height: getHeight(), 'background-color': getColor()}"
    :key="isSelected"
  >
    {{ tubeNumber }}
  </td>
</template>

<script>

export default {
  name: "TableDataTube",

  props: {
    tubeNumber: String,

    isSelected: Boolean,

    fiberPerTubeCache: Object,

    tubeColor: String,

    disabled: {
      type: Boolean,
      default: true
    }
  },
  methods:{
    getHeight(){
      let height;
      if(this.tubeNumber){
        height = 25 * this.fiberPerTubeCache[this.tubeNumber.split(' ')[1]] + 5 *(this.fiberPerTubeCache[this.tubeNumber.split(' ')[1]]-1);   
      }
      if(height){
        return `${height}px`;
      }
      return height;
    },
    getColor(){
      let color;
      if(this.tubeNumber){
        color = this.tubeColor;
      }
      return color
    }
  }
};
</script>

<style scoped>
.selected {
  opacity: 0.35;
  border: 1px solid black
}
.borders{
  border: 1px solid black;
}
.tube-container{
  text-align: center;
  color: white;
  width: 20%;
  margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataTube.vue